import React, { useState } from "react";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import AiTeamDropDown from "../Components/AiTeamDropDown";
import { ReactComponent as SearchIcon } from "../Assets/Icons/search.svg";
import DashboardLayout from "../Layout/DashboardLayout";
import TasksTable from "../Components/TasksTable";
import AddNewAiTask from "../Components/AddNewAiTask";
import EditAiTaskModal from "../Components/EditAiTaskModal";
import AddNewUserModal from "../Components/AddNewUserModal";

const AllTasks = () => {
  const [addTask, setAddTask] = useState(false);
  const [editTask, setEditTask] = useState(false);
  return (
    <DashboardLayout>
      <section className="bg-white px-6 py-4 gap-y-5 w-full flex flex-col items-start">
        <Breadcrumbs links={[{ name: "Tasks", link: "/" }]} />
        <AddNewAiTask open={addTask} setOpen={setAddTask} />
        <EditAiTaskModal
          open={editTask}
          setOpen={setEditTask}
          showProject={true}
        />
        <div className="flex items-center justify-between w-full">
          <h1 className="text-xl font-semibold">All Tasks</h1>
          <button
            className="flex items-center bg-[#942A27] py-2 px-4 rounded-lg mt-2"
            onClick={() => setAddTask(true)}
          >
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 4.5C8.21217 4.5 8.41566 4.58429 8.56569 4.73431C8.71571 4.88434 8.8 5.08783 8.8 5.3V7.7H11.2C11.4122 7.7 11.6157 7.78429 11.7657 7.93431C11.9157 8.08434 12 8.28783 12 8.5C12 8.71217 11.9157 8.91566 11.7657 9.06569C11.6157 9.21571 11.4122 9.3 11.2 9.3H8.8V11.7C8.8 11.9122 8.71571 12.1157 8.56569 12.2657C8.41566 12.4157 8.21217 12.5 8 12.5C7.78783 12.5 7.58434 12.4157 7.43431 12.2657C7.28429 12.1157 7.2 11.9122 7.2 11.7V9.3H4.8C4.58783 9.3 4.38434 9.21571 4.23431 9.06569C4.08429 8.91566 4 8.71217 4 8.5C4 8.28783 4.08429 8.08434 4.23431 7.93431C4.38434 7.78429 4.58783 7.7 4.8 7.7H7.2V5.3C7.2 5.08783 7.28429 4.88434 7.43431 4.73431C7.58434 4.58429 7.78783 4.5 8 4.5V4.5Z"
                fill="white"
              />
            </svg>
            <p className="text-xs text-white font-medium ml-1">Add New</p>
          </button>
        </div>
        <div className="flex items-center gap-6">
          <div className="flex items-center ">
            <div className="rounded-l-lg border flex items-center py-2 px-3 bg-[#F9FAFB] w-[22rem]">
              <SearchIcon />
              <input
                type="text"
                placeholder="Search"
                className="border-none ml-2 bg-inherit w-full text-sm font-medium text-[#6B7280] focus:outline-none"
              />
            </div>
            <div>
              <button className="w-[4.4rem] py-2 px-2 text-[0.95rem] font-[500] text-white rounded-r-lg bg-[#942A27]">
                Search
              </button>
            </div>
          </div>
          <AiTeamDropDown
            text="Status"
            width="8.75rem"
            options={["In Progress", "Completed"]}
          />
          <AiTeamDropDown
            text="Project Name 1"
            width="9.75rem"
            options={["All", "Project Name 1", "Project Name 2"]}
          />
        </div>
      </section>
      <section className="px-6 py-4 w-full">
        <TasksTable setEditTask={setEditTask} />
      </section>
    </DashboardLayout>
  );
};

export default AllTasks;
